import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export default createReduxConstants('APP', {
  INITIALIZE: null
});
